import { Header, Footer, CookieConsent } from '../index';
import Landing2Footer from '../Landing2Footer/Landing2Footer';
import OrganizerFooter from '../OrganizerDashboard/OrganizerFooter';
import Landing2Header from '../Landing2Header/Landing2Header';

const PageWrapper = ({ 
  children, 
  showSearchBar = false, 
  searchData = null, 
  setSearchData = null, 
  handleSearchSubmit = null,
  handleLocationSelect = null,
  showLocationDropdown = false,
  setShowLocationDropdown = null,
  defaultSearchOptions = [],
  landingPage = false,
  useNewFooter = false,
  useOrganizerFooter = false,
  useLanding2Header = false,
  hideHeader = false,
  showPersonaSwitcher = false,
  persona,
  onPersonaChange
}) => {
  return (
    <div className="page-full">
      <div className="page-wrapper">
        {!hideHeader ? (
          <div className={`${useLanding2Header ? 'l2-header-shell' : 'container-padding'} ${!landingPage && !useLanding2Header ? 'border-b border-[#D3D4D6]' : ''}`}>
            {useLanding2Header ? (
              <Landing2Header
                variant="light"
                showPersonaSwitcher={showPersonaSwitcher}
                persona={persona}
                onPersonaChange={onPersonaChange}
              />
            ) : (
              <Header
                showSearchBar={showSearchBar}
                searchData={searchData}
                setSearchData={setSearchData}
                handleSearchSubmit={handleSearchSubmit}
                handleLocationSelect={handleLocationSelect}
                showLocationDropdown={showLocationDropdown}
                setShowLocationDropdown={setShowLocationDropdown}
                defaultSearchOptions={defaultSearchOptions}
                landingPage={landingPage}
              />
            )}
          </div>
        ) : null}
        {children}
      </div>
      {useOrganizerFooter ? (
        <OrganizerFooter />
      ) : useNewFooter ? (
        <Landing2Footer />
      ) : (
        <Footer />
      )}
      <CookieConsent />
    </div>
  );
};

export default PageWrapper;